// extracted by mini-css-extract-plugin
export default {"coursesGrid":"HomePage_coursesGrid__XdwN5"};